import { get } from "../../api/index";
import { API_ENDPOINTS } from "../../constants";

const { APIS } = API_ENDPOINTS;

export const getDashboardDocDealsService = (userID, fromDate, toDate) =>
  new Promise((resolve, reject) => {
    get(
      `${APIS.DASHBOARD}/documents?user_id=${userID}&from_date=${fromDate}&to_date=${toDate}`,
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(
          `dashboardServices => getDashboardDocDealsService => ${error}`,
        );
        reject(error);
      });
  });

export const fetchDashboardSoldProductsService = (userID, fromDate, toDate) =>
  new Promise((resolve, reject) => {
    get(
      `${APIS.DASHBOARD}/sold-products?user_id=${userID}&from_date=${fromDate}&to_date=${toDate}`,
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(
          `dashboardServices => fetchDashboardSoldProductsService => ${error}`,
        );
        reject(error);
      });
  });

export const fetchDashboardAccountsService = (userID, fromDate, toDate) =>
  new Promise((resolve, reject) => {
    get(
      `${APIS.DASHBOARD}/accounts?user_id=${userID}&from_date=${fromDate}&to_date=${toDate}`,
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(
          `dashboardServices => fetchDashboardAccountsService => ${error}`,
        );
        reject(error);
      });
  });

export const fetchDashboardLeaderboardService = (fromDate, toDate) =>
  new Promise((resolve, reject) => {
    get(`${APIS.DASHBOARD}/leaderboard?from_date=${fromDate}&to_date=${toDate}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(
          `dashboardServices => fetchDashboardLeaderboardService => ${error}`,
        );
        reject(error);
      });
  });

export const fetchDashboardDealValuesService = (userID, fromDate, toDate) =>
  new Promise((resolve, reject) => {
    get(
      `${APIS.DASHBOARD}/dealvalues?user_id=${userID}&from_date=${fromDate}&to_date=${toDate}`,
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(
          `dashboardServices => fetchDashboardDealValuesService => ${error}`,
        );
        reject(error);
      });
  });

export const fetchDashboardHighValueDealsService = (userID, fromDate, toDate) =>
  new Promise((resolve, reject) => {
    get(
      `${APIS.DASHBOARD}/highvaluedeals?user_id=${userID}&from_date=${fromDate}&to_date=${toDate}`,
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(
          `dashboardServices => fetchDashboardHighValueDealsService => ${error}`,
        );
        reject(error);
      });
  });
